import { useAssetVizInternal } from 'features/assetViz/AssetVizInternalProvider'
import {
  ComponentSurfaceWrappingMode,
  useSurfaceProps,
} from 'features/assetViz/objects/surfaces/util/SurfaceProvider'
import React, { FC, useMemo } from 'react'
import { GeckoComponentPolygon, GeckoPolygonalPlate } from 'types'

import { PolygonFeatureLabel3D } from './procedural/PolygonFeatureLabel3D'
import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from './procedural/SurfaceLineFeature3D'
import {
  SurfaceMeshFeature3D,
  SurfaceMeshSelectionType,
} from './procedural/SurfaceMeshFeature3D'

export const PolygonalPlateFeature3D: FC<{ model: GeckoPolygonalPlate }> = ({
  model,
}) => {
  const { showPlateFeatureDebugColors } = useAssetVizInternal()
  const { bounds, wrapMode } = useSurfaceProps()

  const boundingPath = useMemo(() => {
    const wrapsX =
      wrapMode === ComponentSurfaceWrappingMode.ComponentWrapsX ||
      wrapMode === ComponentSurfaceWrappingMode.UnrolledComponentWrapsX
    const wrapsY =
      wrapMode === ComponentSurfaceWrappingMode.ComponentWrapsY ||
      wrapMode === ComponentSurfaceWrappingMode.UnrolledComponentWrapsY

    return GeckoComponentPolygon.CreateFromPolygonalPlate(
      model.geometry,
      bounds,
      wrapsX,
      wrapsY
    )
  }, [bounds, model.geometry, wrapMode])

  return (
    <group key={model.id}>
      <SurfaceLineFeature3D
        path={boundingPath}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <SurfaceMeshFeature3D
        path={boundingPath}
        featureModel={model}
        selectionType={SurfaceMeshSelectionType.AssetModelEditorSelectable}
        showDebugColors={showPlateFeatureDebugColors}
        userDataName={'plate'}
      />
      <PolygonFeatureLabel3D feature={model} polygonPath={boundingPath} />
    </group>
  )
}
